import globalStore from "/globalStore.js";


/**
 * The old reports screen is for Lotus staff only. The new reports module (routes.reports.js) replaces it for customers.
 */
const requireLotusStaff = () =>
{
	const user = globalStore.currentUser;
	if (!user) return { path: "/" };

	const isLotusStaff = user.hasFeatureAccess("LotusAdministration.All") || user.hasFeatureAccess("LotusDevelopment.All");
	if (!isLotusStaff) return { path: "/" };
};


const routes = [

	

	//---- "Reports" pages
	{
		path: '/reports/',
		name: "reports-home",
		beforeEnter: requireLotusStaff,
		component: () => import("/reports/index.vue"),
		meta: { layout: "primary", module: "reports", parentRouteName: "", pageTitle: "Reports", breadcrumbLabel: "Reports" }
	},
	{
		//	The page replaces the title with the report's own name once the definition loads
		//	(setPageTitle in report.vue) — the title here is what shows while it does.
		path: '/reports/report/:id',
		name: "report-by-id",
		beforeEnter: requireLotusStaff,
		component: () => import("/reports/report.vue"),
		meta: { layout: "primary",  module: "reports", parentRouteName: "reports-home", pageTitle: "Report", breadcrumbLabel: "Report" }
	},
	{
		path: '/reports/structured-report/:id',
		name: "structured-report-by-id",
		beforeEnter: requireLotusStaff,
		component: () => import("/reports/structured-report.vue"),
		meta: { layout: "primary",  module: "reports", parentRouteName: "reports-home", pageTitle: "Structured Report", breadcrumbLabel: "Report" }
	},
	{
		path: '/reports/database/:id',
		name: "database-report-by-id",
		beforeEnter: requireLotusStaff,
		component: () => import("/reports/database.vue"),
		meta: { layout: "primary",  module: "reports", parentRouteName: "reports-home", pageTitle: "Database Report", breadcrumbLabel: "Database Report" }
	},


		//---- Timesheet module: "Buckets Report" pages
		//TODO: [2026-08-16] not used since 2021, deprecating and removing now (BucketProject-driven burndown report)
		//{
		//	//path: '/buckets',
		//	path: '/module/timesheets/buckets-report',
		//	name: "timesheet-buckets-report-entry",
		//	component: () => import("/module.timesheets/buckets/z_obsolete_index.vue"),
		//	meta: { layout: "primary",  module: "reports", parentRouteName: "home-timesheets-view", pageTitle: "Buckets Report", kbFile: "buckets", kbTitle: "Buckets" }
		//},
		//{ 	// For system admin, and later when a user can operate across accounts
		//	//path: '/buckets/:accountId',
		//	path: '/module/timesheets/buckets-report/:accountId',
		//	name: "timesheet-buckets-report-account",
		//	component: () => import("/module.timesheets/buckets/z_obsolete_index.vue"),
		//	meta: { layout: "primary",  module: "reports", parentRouteName: "home-timesheets-view", pageTitle: "Buckets Report", kbFile: "buckets", kbTitle: "Buckets" }
		//},

		{
			//path: '/buckets/bucket/:bucketId/summary',
			path: '/module/timesheets/buckets-report/bucket/:bucketId/summary',
			name: "timesheet-buckets-report-bucket-summary",
			component: () => import("/module.timesheets/buckets/bucket-summary.vue"),
			meta: { layout: "primary",  module: "reports", parentRouteName: "timesheet-buckets-report-entry", pageTitle: "Bucket Summary", kbFile: "buckets", kbTitle: "Buckets" }
		},
		{
			//path: '/buckets/bucket/:bucketId/detail',
			path: '/module/timesheets/buckets-report/bucket/:bucketId/detail',
			name: "timesheet-buckets-report-bucket-detail",
			component: () => import("/module.timesheets/buckets/bucket-detail.vue"),
			meta: { layout: "primary", layoutType: "manage",  module: "reports", parentRouteName: "timesheet-buckets-report-entry", pageTitle: "Bucket Detail", kbFile: "buckets", kbTitle: "Buckets" }
		},

		{
			//path: '/buckets/bucket/:bucketId/breakdown',
			path: '/module/timesheets/buckets-report/bucket/:bucketId/breakdown',
			name: "timesheet-buckets-report-bucket-breakdown",
			component: () => import("/module.timesheets/buckets/bucket-breakdown.vue"),
			meta: { layout: "primary",  module: "reports", parentRouteName: "timesheet-buckets-report-entry", pageTitle: "Bucket Breakdown", kbFile: "buckets", kbTitle: "Buckets" }
		},


]


export default routes;